$(function () {
  Admin.confirmDelete();
  Admin.imageChooser();
  Admin.fileNameDisplay();
  Admin.partnerForm();
  Admin.cardsFadeIn();
  Admin.cardsLogoFadeIn();
  Admin.setLogoBackgroundColor();
  Admin.validateCSVUpload();
  Admin.addUser();
  Admin.removeUser();
  Admin.addUserRole();
  Admin.limitUserRole();
  Admin.removeUserRole();
  Admin.addCourier();
  Admin.removeCourier();
  Admin.courierComment();
  Admin.generateApiUsernameAndPassword();
  Admin.initPopovers();
  Admin.verifyPartner();
  Admin.revertVerifyPartner();
  Admin.deleteShippingTimeout();
  $('#sidebarMenu')
      .on('show.bs.collapse', function (e) { if($(e.target).hasClass("apc-sidebar")) $(".navbar-wrapper").css("bottom", "0");})
      .on('hide.bs.collapse', function (e) { if($(e.target).hasClass("apc-sidebar")) $(".navbar-wrapper").css("bottom", "");});
});

var Admin = {

  toggleMobileMenu: function(){
    $(".navbar-wrapper").css("bottom", "0");
  },

  confirmDelete: function () {
    $('.confirm-delete').click(function (event) {
      if (!confirm("Oled kindel, et tahad kustutada?")) {
        event.preventDefault();
      }
    });
  },

  fileNameDisplay: function () {
    $('[type=file]:not(.hidden)').change(function () {
      console.log("fnd");
      var name = $(this).val();

      var input_id = $(this).attr("id");
      if (name.indexOf('/') != -1) name = name.substring(name.lastIndexOf('/') + 1);
      if (name.indexOf('\\') != -1) name = name.substring(name.lastIndexOf('\\') + 1);
      if ($("label[for = '"+this.id+"']")) {
        $("label[for = '"+this.id+"']").text(name);
      } else {
        $('body').append('<style>.' + input_id + '-file-input:after{content:"' + name + '"}</style>');
      }

    });
  },

  imageChooser: function () {
    $.each($('.image-upload'), function (i, form) {
      $(form).find('a').click(function () {
        var input = $(form).find('input');
        input.click();
        input.change(function () {
          this.form.submit();
        })
      })
    });
  },

  partnerForm: function () {
    var partnerForm = $('#partner-form');

    partnerForm.find('[name=deliveryChannel]').on('change', Admin.selectDeliveryChannel);

    var smartpostSelected = $('#delivery-channel-2')[0];
    if (smartpostSelected && smartpostSelected.checked)
      $('#smartpost-preferred-terminal').toggle(true);


    partnerForm.find('#name').on('change', function () {
      var name = $(this).val();
      var url = ('/apc/address/' + name + '/');
      $.get(url, function (response) {
        partnerForm.find('#address').val(response.address)
      })
    }).trigger('change');

    partnerForm.submit(this.validatePartnerForm);
  },

  validatePartnerForm: function (event) {

    var fs = $('input[type="file"]');
    var filesOK = true;
    fs.each(function(i,fel) {
      if (!FormValidation.checkFileSize(fel)) {
        filesOK = false;
      }
    });

    var mandatoryFields = ["name", "deliveryChannel"];
    FormValidation.hasMandatoryValues(mandatoryFields, event) && filesOK;
  },

  selectDeliveryChannel: function (event) {
    var clickedDeliveryChannel = $(event.target);
    var selectedPreferredDeliveryChannel = $('[name=preferredDeliveryChannel] option:selected');

    if (clickedDeliveryChannel.val() === selectedPreferredDeliveryChannel.val()) {
      clickedDeliveryChannel.prop('checked', true)
    }
    var preferredDeliveryChannel = $('[name=preferredDeliveryChannel] option[value=' + clickedDeliveryChannel.val() + ']')
      .toggle(clickedDeliveryChannel.is(":checked"))

    var smartPostPDC = $('#smartpost-preferred-terminal');
    if (clickedDeliveryChannel.val() === '2')
      smartPostPDC.toggle(clickedDeliveryChannel.is(":checked"));

  },

  filterWith: function (target, filter) {
    var newUrl = new window.URL(window.location.href);
    if (target.val() === 'undefined')
      newUrl.searchParams.delete(filter);
    else
      newUrl.searchParams.set(filter, target.val());
    newUrl.searchParams.delete('p');
    window.location.href = newUrl;
  },

  cardsFadeIn: function () {
    $(".card-image.lazy").lazyload({
      effect: "fadeIn"
    });
  },

  cardsLogoFadeIn: function () {
    var lazyLoadCardLogo = $(".card-logo.lazy-logo");
    if (lazyLoadCardLogo.length) {
      lazyLoadCardLogo.lazyload({
        event: "scroll forceLazyLoad",
        effect: "fadeIn",
        failure_limit: $(lazyLoadCardLogo).length,
        load: function () {
          var img = $(this).data("original");
          var self = $(this);
          RGBaster.colors(img, {
            paletteSize: 10,
            exclude: ['rgb(0,0,0)'],
            success: function (payload) {
              if (payload.dominant == 'rgb(255,255,255)' && payload.secondary == 'rgb(0,0,0)') {
                $(self).closest(".card").addClass('white-logo');
              }
            }
          });
        }
      });
    }
  },

  setLogoBackgroundColor: function () {
    var avatarLogos = $(".js-set-logo-background-color");
    if (avatarLogos.length) {
      $(avatarLogos).each(function () {
        var imgTag = $(this);
        var img = imgTag.css('background-image').trim();
        var img = img.replace(/.*\s?url\([\'\"]?/, '').replace(/[\'\"]?\).*/, '');
        RGBaster.colors(img, {
          paletteSize: 10,
          exclude: ['rgb(0,0,0)'],
          success: function (payload) {
            if (payload.dominant == 'rgb(255,255,255)' && payload.secondary == 'rgb(0,0,0)') {
              imgTag.addClass('bg-black');
            }
          }
        });
      });
    }
  },

  validateCSVUpload: function () {
    $('#csv-upload-form').on('submit', function (event) {
      var mandatoryFields = ["csv"];
      FormValidation.hasMandatoryValues(mandatoryFields, event);
    });
  },

  verifyPartner: function () {
    $('#verify-partner').on('click', function (e) {
      e.preventDefault();
      $.post('/apc/partner/edit/' + $('#partnerId').val() + '/verify/')
        .done(function () {
          window.location.reload();
        })
    })
  },


  revertVerifyPartner: function () {
    $('#verify-partner-revert').on('click', function (e) {
      e.preventDefault();
      $.post('/apc/partner/edit/' + $('#partnerId').val() + '/verify/revert/')
        .done(function () {
          window.location.reload();
        })
    })
  },

  addUser: function () {
    $('.add-user').on('click', function () {
      var error = $('#partner-users-error').hide();

      $.post('/apc/partner/' + $('#partnerId').val() + '/user/' + $('#username').val() + '/').done(function (response) {
        if (response.username) {
          // For adding more than one user at a time, added to the end of the list after the current
          // partner user row is finished.
          let hiddenAddedPartnerHtml = document.getElementById('added-partner-user').cloneNode(true);

          // Unhiding the hidden partner user row so that end user can see and modify added partner user data.
          let addedPartnerUserRow = document.getElementById('added-partner-user');
          addedPartnerUserRow.hidden = false;

          let fullName = response.fullName ? (" (" + response.fullName + ")") : "";
          $('#added-partner-user-name').text(response.username + fullName);

          // Adding new partner user's username as data-username attribute so adding roles and centers to the new
          // partner user could work asynchronously.
          let roleCheckboxesList = addedPartnerUserRow.getElementsByTagName('a');
          for (let roleCheckbox of roleCheckboxesList) {
            roleCheckbox.setAttribute('data-username', response.username);
          }

          let addedPartnerUserCenterList = document.getElementById('added-partner-user-center-list');
          addedPartnerUserCenterList.getElementsByTagName('select')[0]
              .setAttribute('data-username', response.username);

          let addedPartnerUserDeleteButton = document.getElementById('added-partner-user-delete-button');
          addedPartnerUserDeleteButton.setAttribute('data-username', response.username);

          // Changing id-s so other new users can be added and modified asynchronously.
          addedPartnerUserRow.id = response.username + '-added';
          document.getElementById('added-partner-user-name').id = response.username + '-name';
          addedPartnerUserCenterList.id = response.username + '-center-list';
          addedPartnerUserDeleteButton.id = response.username + '-delete-button';

          $('#username').val('');
          $('#partner-users').append(hiddenAddedPartnerHtml);
        }
        if (response.error) {
          error.html(response.error).show();
        }
      }).fail(function (response) {
        console.log(response);
        error.html('Kasutajat ei õnnestunud lisada!').show();
      });
      return false;
    })
  },

  removeUser: function () {
    $('#partner-users').on('click', '.delete', function (e) {
      if (confirm($('#partner-users-confirm').text().toString())) {
        var error = $('#partner-existing-users-error').hide();
        $.ajax({
          url: '/apc/partner/' + $('#partnerId').val() + '/user/' + $(e.target.closest('a')).data('username') + '/',
          type: 'DELETE'
        }).done(function () {
          $(e.target).closest('tr').remove();
        }).fail(function (response) {
          console.log(response);
          error.html('Kustutamisel tekkis viga! Palun värskenda lehte!').show();
        });
      }

      return false;
    });
  },

  addUserRole: function () {
    $('#partner-users').on('click', '.addrole', function (e) {
      if (confirm($('#partner-users-confirm').text().toString())) {
        var pid = $('#partnerId').val();
        var error = $('#partner-existing-users-error').hide();
        $.ajax({
          url: '/apc/partner/' + pid + '/user/' + $(e.target).data('username') + '/add/',
          data:{'role': $(e.target).data('rolename'), 'center': pid + '-center'},
          type: 'PUT'
        }).done(function () {
          window.location.reload();
        }).fail(function (response) {
          console.log(response);
          error.html('Salvestamisel tekkis viga!').show();
        });
      }

      return false;
    });
  },

  limitUserRole: function () {
    $('#partner-users').on('change', '.center-select', function (e) {
      if (confirm($('#partner-users-confirm').text().toString())) {
        var error = $('#partner-existing-users-error').hide();
        $.ajax({
          url: '/apc/partner/' + $('#partnerId').val() + '/user/' + $(e.target).data('username') + '/add/',
          data:{'center': $(e.target).val()},
          type: 'PUT'
        }).done(function () {
          window.location.reload();
        }).fail(function (response) {
          console.log(response);
          error.html('Salvestamisel tekkis viga!').show();
        });
      }

      return false;
    });
  },

  removeUserRole: function () {
    $('#partner-users').on('click', '.removerole', function (e) {
      var error = $('#partner-existing-users-error').hide();
      if (confirm($('#partner-users-confirm').text().toString())) {
        $.ajax({
          url: '/apc/partner/' + $('#partnerId').val() + '/user/' + $(e.target).data('username') + '/remove/',
          data:{'role': $(e.target).data('rolename')},
          type: 'PUT'
        }).done(function () {
          window.location.reload();
        }).fail(function (response) {
          console.log(response);
          error.html('Salvestamisel tekkis viga!').show();
        });
      }

      return false;
    });
  },

  addCourier: function () {
    $('.add-courier').on('click', function () {
      var error = $('#delivery-channel-couriers-error').hide();

      $.post('/apc/couriers/' + $('#delivery-channel-slug').val() + '/' + $('#username').val() + '/').done(function (response) {
        if (response.username) {
          var fullName = response.fullName ? (" (" + response.fullName + ")") : "";
          var li = $("<li></li>");
          var deleteLink = $('<a class="delete ml-2" href="#">&times;</a>');
          deleteLink.data('username', response.username);
          li.text(response.username + fullName);
          li.append(deleteLink);
          $('#delivery-channel-couriers').append(li);
          $('#username').val('');
        }
        if (response.error) {
          error.text(response.error).show();
        }
      });

      return false;
    })
  },

  removeCourier: function () {
    $('#delivery-channel-couriers').on('click', '.delete', function (e) {
      if (confirm($('#delivery-channel-couriers-confirm').text().toString())) {
        $.ajax({
          url: '/apc/couriers/' + $('#delivery-channel-slug').val() + '/' + $(e.target).data('username') + '/',
          type: 'DELETE'
        }).done(function () {
          $(e.target).closest('li').remove();
        });
      }

      return false;
    });
  },

  courierComment: function () {
    $('#admin-courier-comment').on('input', function () {
      var self = $(this), timerId = self.data('timer-id');
      if (timerId) clearTimeout(timerId);
      self.data('timer-id', setTimeout(function () {
        $.post(self.attr('href'), {comment: self.val()})
      }, 1000))
    })
  },

  initPopovers: function () {
    $('[data-toggle="popover"]').popover({
      container: 'body',
      trigger: 'hover',
      placement: 'top'
    })
  },

  generateApiUsernameAndPassword: function () {
    var modal = $('#api-password-modal');
    var partnerId = $('#partnerId').val();
    modal.find('button.btn-success').on('click', function () {
      $.post('/apc/partner/api/' + partnerId + '/generate-key/').complete(function (response) {
        console.log(response);
        modal.find('.alert.alert-warning').hide();
        modal.find('.alert.alert-info').show();
        modal.find('button.btn-success').hide();
        modal.find('div.result').text(response.responseText);
      })
    });
  },

  editCategory: function (target) {
    var url = new window.URL(window.location.href + 'edit/');
    url.searchParams.set('field', $(target).attr('name'));
    url.searchParams.set('category', $(target).attr('value'));
    url.searchParams.set('checked', $(target).is(':checked'));
    $.post(url)
      .done(() => {alert('kategooria muudetud')})
      .fail(() => {alert('muutmine ebaõnnestus. Palun värskenda lehte.')});
  },

    deleteShippingTimeout: function () {
        $('#delete-shipping-timeout').on('click', function (e) {
            if (confirm($('#delete-shipping-timeout-confirm').text().toString())) {
                $('#deliveryTimeoutStart').val('');
                $('#deliveryTimeoutEnd').val('');
            }
            return false;
        });
    }

};
